import { SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { usePersistentForm } from '~/components/utils/PersistentForm';
import { TERMS_OF_SERVICES_CURRENT_VERSION } from '~/hooks/useTermsOfServicesAcceptationStatus';
import { useApi } from '~/lib/api';
import { useUpdateUserTosMutation } from '~/lib/api/modules/Users/hooks/useUpdateUserTosMutation';
import {
  INewTermsOfServicesFormMainSectionFormValues,
  NewTermsOfServicesFormMainSection,
} from './NewTermsOfServicesFormMainSection';

export type INewTermsOfServicesFormProps = IContainerProps & {
  onSuccess: () => void;
};

export const NewTermsOfServicesForm: React.FC<INewTermsOfServicesFormProps> = (
  props,
) => {
  const { sx, onSuccess } = props;
  const { t } = useTranslation();
  const tosMutation = useUpdateUserTosMutation();
  const form = usePersistentForm<INewTermsOfServicesFormMainSectionFormValues>({
    defaultValues: {},
    excludeFields: ['userLicenceAgreement', 'termsOfServiceAgreement'],
  });

  const api = useApi();
  const currentUserId = api.getCurrentUserId();

  const handleSubmit: SubmitHandler<
    INewTermsOfServicesFormMainSectionFormValues
  > = ({ termsOfServiceAgreement, userLicenceAgreement }) => {
    if (tosMutation.isLoading) {
      return;
    }
    if (!termsOfServiceAgreement || !userLicenceAgreement) {
      return;
    }
    if (!currentUserId) {
      window.location.href = '/';
      return;
    }

    return tosMutation.mutateAsync(
      {
        userId: currentUserId,
        body: {
          optIn: [TERMS_OF_SERVICES_CURRENT_VERSION],
        },
      },
      { onSuccess },
    );
  };

  return (
    <ContentBlock sx={sx}>
      <ContentBlock.FormBody
        form={form}
        onSubmit={handleSubmit}
        submitButtonLabel={t('NewTermsOfServicesForm.agree')}
        first
      >
        <NewTermsOfServicesFormMainSection form={form} />
      </ContentBlock.FormBody>
    </ContentBlock>
  );
};
